import { Routes, Route, Navigate } from "react-router-dom";
import { AuthGuard } from "@/components/AuthGuard.js";
import { AppLayout } from "@/layouts/AppLayout.js";
import { LoginPage } from "@/pages/LoginPage.js";
import { TenantsPage } from "@/pages/TenantsPage.js";
import { TenantEditPage } from "@/pages/TenantEditPage.js";
import { AdminsPage } from "@/pages/AdminsPage.js";
import { MainSiteSettingsPage } from "@/pages/MainSiteSettingsPage.js";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AuthGuard><AppLayout /></AuthGuard>}>
        <Route path="/" element={<Navigate to="/tenants" replace />} />
        <Route path="/tenants" element={<TenantsPage />} />
        <Route path="/tenants/new" element={<TenantEditPage />} />
        <Route path="/tenants/:id/edit" element={<TenantEditPage />} />
        <Route path="/admins" element={<AdminsPage />} />
        <Route path="/settings" element={<MainSiteSettingsPage />} />
        <Route path="*" element={<Navigate to="/tenants" replace />} />
      </Route>
    </Routes>
  );
}
